import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { LayoutService } from '../../core/services/conf/layout.service';
import { ConfiguratorComponent } from '../configurator/configurator.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../core/services/api/auth.service';
import { NotificationService } from '../../shared/components/notification-modal/notification.service';

interface BranchOption {
    idBranch: number;
    name: string;
    code: string;
}

@Component({
    selector: 'app-topbar',
    imports: [RouterModule, StyleClassModule, ConfiguratorComponent, TooltipModule, DialogModule, ButtonModule, SelectModule, FormsModule],
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
    items!: MenuItem[];
    private authService = inject(AuthService);
    private notifier = inject(NotificationService);
    rolUser = this.authService.getUserRole();
    user: boolean = false;
    displayConfirmation: boolean = false;
    nombreUsuario: string = '';
    sucursal: string = '';

    canSwitchBranch: boolean = false;
    branches: BranchOption[] = [];
    selectedBranch: BranchOption | null = null;
    switchingBranch: boolean = false;

    constructor(
        public layoutService: LayoutService,
        private router: Router
    ) {
        const roleUser = !this.authService.hasRole('CUSTOMER');

        console.log(this.rolUser);

        this.user = roleUser;
        if (!this.user) {
            this.layoutService.onMenuToggle();
        }
    }

    ngOnInit() {
        this.nombreUsuario = 'Bienvenido/a ' + this.authService.getCurrentUser()?.firstName + ' ' + this.authService.getCurrentUser()?.lastName || '';
        this.sucursal = this.authService.getCurrentUser()?.branch || 'ninguna';

        this.canSwitchBranch = this.authService.hasRole('Root') || this.authService.hasRole('Administrador');
        if (this.canSwitchBranch) {
            this.loadBranches();
        }
    }

    private loadBranches(): void {
        this.authService.getActiveBranches().subscribe({
            next: (res: any) => {
                const list: any[] = res?.object ?? [];
                this.branches = list.map((b: any) => ({
                    idBranch: b.idBranch,
                    name: b.name,
                    code: b.code
                }));
                const currentBranch = this.authService.getCurrentUser()?.branch;
                if (currentBranch) {
                    this.selectedBranch = this.branches.find(b => b.name === currentBranch) ?? null;
                }
            },
            error: () => {
                this.branches = [];
            }
        });
    }

    onBranchChange(): void {
        if (!this.selectedBranch || this.switchingBranch) return;
        const target = this.selectedBranch;
        const currentBranch = this.authService.getCurrentUser()?.branch;
        if (target.name === currentBranch) return;

        this.switchingBranch = true;
        this.authService.switchBranch(target.idBranch).subscribe({
            next: (response: any) => {
                this.switchingBranch = false;
                this.sucursal = this.authService.getCurrentUser()?.branch || target.name;
                if (response.data?.branchReassigned) {
                    this.notifier.info(
                        `🏢 Reasignado a sucursal "${response.data?.newBranchName || target.name}"`,
                        '',
                        4000
                    );
                }
                setTimeout(() => window.location.reload(), 1500);
            },
            error: () => {
                this.switchingBranch = false;
                this.selectedBranch = this.branches.find(
                    b => b.name === this.authService.getCurrentUser()?.branch
                ) ?? null;
            }
        });
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: !state.darkTheme
        }));
    }

    goto(ruta: string) {
        this.router.navigate([ruta]);
    }

    openConfirmation() {
        this.displayConfirmation = true;
    }

    closeConfirmation(confirmation: boolean) {
        if (confirmation) {
            this.authService.logout();
        }
        this.displayConfirmation = false;
    }
}
